/* eslint-disable max-classes-per-file */
export class ValidationError extends Error {
  constructor(message, errors) {
    super(message);

    const errs = {};

    // get first error message for each field
    errors.slice().reverse().forEach((e) => {
      if (e.param !== '_error') {
        errs[e.param] = e.msg;
      }

      if (e.param === '_error') {
        errs[e.nestedErrors[0].param] = e.nestedErrors[0].msg;
      }
    });

    this.errors = errs;
  }
}

export class InvalidCredentialsError extends Error { }
